import PageMeta from "../../components/common/PageMeta";
import {
    API_BASE_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import Cards from "./Cards";
import TopStylists from "./TopStylist";
import { useEffect, useState } from "react";
import { handleApiCall } from "../../utilities/helper";
import InsiderListPage from "./InsiderListPage";

const InsiderDashboard = () => {
        const [loading, setLoading] = useState(true);
        const [data, setData] = useState({});
        const [controller, setController] = useState(null);
    
        const callListApi = async () => {
            controller?.abort();
            const newController = new AbortController();
            setController(newController);
            const { signal } = newController;
            setLoading(true);
            try {
    
                const response = await handleApiCall(
                    `${API_BASE_URL}/api/backoffice/insidercircle/analytics`,
                    {
                        method: "GET"
                    },
                    null,
                    signal
                );
                if (response.responseStatus == true) {
                    setData(response.data);
                } else {
                    setData(null);
                }
                if (response.responseCode !== 299) {
                    setLoading(false);
                }
            } catch (e) {
                console.error("Error", e);
            } finally {
                setLoading(false);
            }
        };
    
        useEffect(() => {
            callListApi();
        }, []);

    
    return (
        <>
            <PageMeta
                title={`Insider Dashboard - ${DEFAULT_PAGE_TITLE}`}
                description={`Insider Dashboard - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <PageBreadcrumb pageTitle="Insider Dashboard" />
            <div className="grid grid-cols gap-4 md:gap-6">
                <div className="">
                    <Cards />
                </div>
                {/* col-span-12 xl:col-span-5 */}
                <div className="">
                    <TopStylists topStylists={data?.topStylists} topReferrers={data?.topReferrers}/>
                </div>
            </div>
            <hr className="my-6 border-gray-200 dark:border-gray-700" />
            <div className=" ">
                    <InsiderListPage/>
                </div>
        </>
    );
};

export default InsiderDashboard;
